<template>
  <div>
    <div class="newList">
       <div class="ItemList" id="NewsItem">
          <div class="NewsItem">
            <el-row>
              <el-col :span="8" v-for="(item, index) in JpgcList" :key="index" style="margin-bottom:60px">
                <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank" class="JpItem">
                  <div class="img">
                    <img class="swiper_img" :src="item.thumb1" style="width: 283px;height: 197px;" />
                  </div>
                  <div class="Tit">{{ item.title }}</div>
                  <div class="nr"></div>
                </a>
                <a
                  v-else
                  @click="((val)=>{todel(val,item.entTArticleUuid)})"
                  class="JpItem"
                >
                  <div class="img">
                    <img class="swiper_img" :src="item.thumb1" style="width: 100%; height: 242px;" />
                  </div>
                  <div class="Tit">{{ item.title }}</div>
                  <div class="nr">
                    查看详情
                  </div>
                </a>
              </el-col>
            </el-row>
          </div>
        </div>
    </div>
    <div class="pagin" v-if="totalPages>1">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        :pager-count="11"
        layout="prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { articles,picArticles } from '@/api/common'
export default {
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      newsList: [],
      newsList1:[],
      newsList2:[],
      newsList3:[],
      pageSize: 15,
      pageNum: 1,
      total: 0,
      totalPages:0,
      JpgcList:[]
    }
  },
  filters: {
    //超过100位显示 ...
    ellipsis: function(value) {
      if (!value) return ''
      if (value.length > 120) {
        return value.slice(0, 120) + '...'
      }
      return value
    }
  },
  computed: {},
  watch: {
    $route(val) {
      this.fullPath = val.fullPath
    }
  },
  mounted() {
    var _this = this
    this.$nextTick(() => {
      _this.articles()
    })
    this.bannerJpgc()
  },
  methods: {
    //精品工程轮播图
    bannerJpgc() {
      var _this = this
      let data = {
        entTApplicationUuid: _this.webId,
        channelUuid: _this.id,
        pageNum: 1,
        pageSize: 9
      }
      picArticles(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.JpgcList = data.rows
        }
      })
    },

    todel(val,entTArticleUuid){
      let routeUrl =  this.$router.resolve({path:this.fullPath,query:{entTArticleUuid:JSON.stringify(entTArticleUuid)}})
      window.open(routeUrl.href, '_blank')
    },
    articles() {
      var _this = this

      let data = {
        entTApplicationUuid: _this.webId,
        channelUuid: _this.id,
        pageNum: _this.pageNum,
        pageSize: _this.pageSize
      }
      articles(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsList = data.rows
          _this.total = data.totalRows
          _this.totalPages = data.totalPages
          _this.newsList1 = _this.newsList.slice(0,5)
          _this.newsList2 = _this.newsList.slice(5,10)
          _this.newsList3 = _this.newsList.slice(10,15)
        }
      })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      var _this = this
      _this.pageNum = val
      _this.articles()
    }
  }
}
</script>

<style lang="scss">
.newList {
  width: 910px;
  height: auto;
  overflow: hidden;
  margin: 20px auto 0px;
}
.newList .el-divider--horizontal{
  margin: 10px 0;
}
.newList .ItemList {
  width: 100%;
  overflow: hidden;
}
.newList .ItemList .comUl {
  padding-left: 0px;
}
.newList .ItemList .comUl li {
  width: 100%;
  height: 38.4px;
  line-height: 38.4px;
  // background: url(../../../../assets/image/li.jpg) left center no-repeat;
  text-indent: 1.2em;
}
.newList .ItemList .comUl li a {
  float: left;
  white-space: nowrap;
  display: block;
  text-align: left;
  text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
  width: 80%;
  color: #000000;
  font-size: 15px;
}

.newList .ItemList .comUl li a:hover {
  animation: comUla 0.2s linear 1;
  color: #4d4d44d4;
}
@keyframes comUla {
  from {
    transform: translateY(+1px);
  }
  to {
    transform: translateY(+1px);
  }
}
.pagin{
  text-align: center;
  margin-top: 20px;
}
.comUl li span {
  float: right;
  font-size: 15px;
}
.JpItem {
  width: 283px;
  display: block;
  overflow: hidden;
}
 .JpItem .img {
  width: 283px;
  height: 197px;
  overflow: hidden;
}
.JpItem .img img {
  transition: all 0.5s ease-in;
  -webkit-transition: 0.5s all ease-in; /* 适用Safari 和 Chrome兼容 */
  -moz-transition: 0.5s all ease-in; /* 适用Firefox兼容 */
  -ms-transition: 0.5s all ease-in; /* 适用IE9兼容 */
  -o-transition: 0.5s all ease-in; /* Opera */
}
.JpItem .Tit {
  width: 100%;
  height: 30px;
  text-align: center;
  margin: 5px 0px;
  line-height: 30px;
  font-weight: bolder;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 13px;
  color: #424242;
}
.JpItem .nr {
  width: 96px;
  height: 30px;
  border: 1px #d2d2d2 solid;
  line-height: 30px;
  text-align: center;
  color: #ec0404;
  margin: 10px auto 0px auto;
  font-size: 13px;
}
.JpItem .img {
  width: 100%;
  height: 197px;
  overflow: hidden;
}
.JpItem:hover .img img {
  transform: scale(1.2);
  -webkit-transform: scale(1.2); /*在Safari 和 Chrome兼容下还原*/
  -moz-transform: scale(1.2); /*在Firefox兼容下还原*/
  -ms-transfrom: scale(1.2); /*在IE9兼容下还原*/
  -o-transform: scale(1.2); /*在opera兼容下还原*/
  transform: scale(1.2); /*适用于所有浏览兼容下还原*/
}
.JpItem:hover .Tit{
  // color: #0162b3;
  cursor: pointer;
}
.JpItem:hover .nr{
  // color: #0162b3;
  cursor: pointer;
}

</style>
